







import globals from "@/general/store/modules/globals";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class LoadingProcess extends Vue {
  get isProcess() {
    return globals.loadingProcess;
  }
}
